import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import { AiOutlineHome, AiOutlineUser, AiOutlineFundProjectionScreen } from "react-icons/ai";
import { FaBowlFood, FaBomb } from "react-icons/fa6";
import { IoFastFood } from "react-icons/io5";
import { CgFileDocument } from "react-icons/cg";
import { FaGithub } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import { IoMdContact } from "react-icons/io";
import { LiaCertificateSolid } from "react-icons/lia";


import NavDropdown from "react-bootstrap/NavDropdown"; // Import NavDropdown

import '../App.css';

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex">
          {/* Add logo if necessary */}
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/about" onClick={() => updateExpanded(false)}>
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/project" onClick={() => updateExpanded(false)}>
                <AiOutlineFundProjectionScreen style={{ marginBottom: "2px" }} /> Projects
              </Nav.Link>
            </Nav.Item>            
            <Nav.Item>
              <Nav.Link as={Link} to="/resume" onClick={() => updateExpanded(false)}>
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>            
            <Nav.Item>
              <Nav.Link as={Link} to="/leetcode" onClick={() => updateExpanded(false)}>
                <SiLeetcode style={{ marginBottom: "2px" }} /> Leetcode
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/github" onClick={() => updateExpanded(false)}>
                <FaGithub style={{ marginBottom: "2px" }} /> GitHub
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/contact" onClick={() => updateExpanded(false)}>
                <IoMdContact  style={{ marginBottom: "2px" }} /> Contact
              </Nav.Link>
            </Nav.Item>
            <NavDropdown title="More" id="collasible-nav-dropdown">
            <NavDropdown.Item as={Link} to="/certificates" onClick={() => updateExpanded(false)}>
                <LiaCertificateSolid style={{ marginBottom: "2px" }} /> Certificates
              </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/foodblog" onClick={() => updateExpanded(false)}>
                <FaBowlFood style={{ marginBottom: "2px" }} /> Food Blog
              </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/foodwishlist" onClick={() => updateExpanded(false)}>
                <IoFastFood style={{ marginBottom: "2px" }} /> Food WishList
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/secret" onClick={() => updateExpanded(false)}>
                <FaBomb style={{ marginBottom: "2px" }} /> Studio
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
